import clsx from 'clsx';
import Modal from 'components/common/modal';
import { ProjectAttachmentType } from 'data/types';
import { Dispatch, SetStateAction } from 'react';

type ChooseEquipmentImageModalProps = Readonly<{
  openState: [boolean, Dispatch<SetStateAction<boolean>>];
  attachments: ProjectAttachmentType[];
  assignedImageId?: number | null;
  onSelect: (attachmentId: number) => void;
}>;

export default function ChooseEquipmentImageModal({
  openState,
  attachments,
  assignedImageId,
  onSelect
}: ChooseEquipmentImageModalProps) {
  return (
    <Modal
      openState={openState}
      title='Choose Equipment Photo'
      size='wide'
      infoMode
    >
      {attachments.length === 0 ? (
        <p className='text-center text-sm text-gray-500'>
          No equipment photos have been uploaded yet.
        </p>
      ) : (
        <div className='flex flex-wrap justify-center gap-3'>
          {attachments.map((attachment) => (
            <button
              key={attachment.id}
              type='button'
              onClick={() => onSelect(attachment.id)}
              className={clsx(
                'flex flex-col items-center gap-1 rounded-md border-2 p-2 hover:bg-gray-50',
                attachment.id === assignedImageId
                  ? 'border-blue-500'
                  : 'border-gray-200'
              )}
            >
              <img
                src={attachment.url ?? ''}
                alt={attachment.name}
                className='h-28 w-28 rounded object-contain'
                draggable={false}
              />
              <span className='max-w-[112px] truncate text-xs text-gray-600'>
                {attachment.name}
              </span>
            </button>
          ))}
        </div>
      )}
    </Modal>
  );
}
